import { useEffect } from "react";
import { createWakeLockKeeper } from "src/utils/screen-wake-lock";

/**
 * Hold a screen wake lock while `active` is true. Best effort: silently does
 * nothing where the API is missing or refused. See utils/screen-wake-lock.ts.
 */
export function useScreenWakeLock(active: boolean): void {
  useEffect(() => {
    if (!active) return;
    const keeper = createWakeLockKeeper();
    keeper.start();
    return () => keeper.stop();
  }, [active]);
}
